<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperBooksCatalog',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'BooksCatalogModule',
    };
  },
};
</script>
